import UsernameSupplier from "./UsernameSupplier";
import localforage from "localforage";

export const USERNAME_LOCALFORAGE_KEY: string = "username";
export default class AuthUsernameSupplierCachedDecorator implements UsernameSupplier {
    readonly delegate: UsernameSupplier;

    constructor(
        delegate: UsernameSupplier
    ) {
        this.delegate = delegate;
    }

    public async get(): Promise<string> {
        let username: string | null = await localforage.getItem(USERNAME_LOCALFORAGE_KEY);
        if (!username) {
            username = await this.delegate.get();
            localforage.setItem(USERNAME_LOCALFORAGE_KEY, username);
        }
        return username;
    }
}